export default [
  /********************************************
   * 人脸管理
   *******************************************/
  {
    path: '/faceInput',
    name: 'PageFaceInputIndex',
    component: () =>
      import(
        /* webpackChunkName: "others" */ '../pages/others/PageFaceInputIndex'
      ),
    meta: { modular: 5, title: '人脸录入', info: '人脸录入' }
  },
  {
    path: '/faceStandard',
    name: 'PageFaceStandard',
    component: () =>
      import(
        /* webpackChunkName: "others" */ '../pages/others/PageFaceStandard'
      ),
    meta: { modular: 5, title: '人脸录入管理', info: '人脸录入管理' }
  },
  {
    path: '/arrived',
    name: 'PageArrived',
    component: () =>
      import(/* webpackChunkName: "others" */ '../pages/others/PageArrived'),
    meta: { modular: -1, title: '我已到校', info: '我已到校' }
  },
  {
    path: '/schoolbus',
    name: 'PageSchoolbus',
    component: () =>
      import(/* webpackChunkName: "others" */ '../pages/others/PageSchoolbus'),
    meta: { modular: -1, info: '校园巴士' }
  },
  {
    path: '/qrcode',
    name: 'PageQrcode',
    component: () =>
      import(/* webpackChunkName: "others" */ '../pages/others/PageQrcode'),
    meta: { modular: -1, info: '二维码' }
  },
  {
    path: '/aiBox/index',
    name: 'PageAiBox',
    component: () =>
      import(/* webpackChunkName: "others" */ '../pages/others/PageAiBox'),
    meta: { modular: -1, title: '无感设备', info: '无感设备' }
  },
  {
    path: '/aiBox/campus',
    name: 'PageAiCampus',
    component: () =>
      import(/* webpackChunkName: "others" */ '../pages/others/PageAiCampus'),
    meta: { modular: -1, title: '配置安全盒子', info: '配置安全盒子' }
  },
  {
    path: '/disciplinary/campus',
    name: 'PageDisciplinary',
    component: () =>
      import(
        /* webpackChunkName: "others" */ '../pages/others/PageDisciplinary'
      ),
    meta: { modular: -1, title: '配置大屏', info: '配置大屏' }
  },
  {
    path: '/other/authorize',
    name: 'PageAuthorize',
    component: () =>
      import(/* webpackChunkName: "others" */ '../pages/others/PageAuthorize'),
    meta: {
      modular: -1,
      clearCachedViews: true,
      keepAlive: true,
      info: '授权'
    }
  },
  {
    path: '/pure/middle',
    name: 'PagePureMiddle',
    component: () =>
      import(/* webpackChunkName: "others" */ '../pages/others/PagePureMiddle'),
    meta: { modular: -1, title: '', info: '' }
  }
]
